@if ((volume$ | async); as volume) {
  <div
    class="container">
    <div style="display: flex;flex-direction: row">
      <div [style.background-color]="volume.hexColor"
      style="width: 5px; height: 31px;"></div>
      <div style="padding-left: 10px;">
        <div>{{volume.name}}</div>
        <div style="font-size: smaller">{{volume.volume | number:'1.2-2'}} m3</div>
      </div>
    </div>
    <div class="icons">
      @if (!volume.show) {
        <mat-icon>visibility_off</mat-icon>
      }
      <mat-icon>share</mat-icon>
    </div>
  </div>
}



